import styled from 'styled-components/native';

export const Container = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 0px;
`;
export const DayContainer = styled.View`
  width: 35px;
  height: 35px;
  justify-content: center;
  align-items: center;
  margin: 0px 9px;
`;
export const DayText = styled.Text`
  font-size: 16px;
  color: #03a487;
`;
